import { render } from "./SalesEvents.vue?vue&type=template&id=2bc4b491"
import script from "./SalesEvents.vue?vue&type=script&lang=js"
export * from "./SalesEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SalesEvents/SalesEvents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc4b491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc4b491', __exports__)) {
    api.reload('2bc4b491', __exports__)
  }
  
  module.hot.accept("./SalesEvents.vue?vue&type=template&id=2bc4b491", () => {
    api.rerender('2bc4b491', render)
  })

}


export default __exports__